// extracted by mini-css-extract-plugin
export default {"fieldTitleDocuments":"RejectModal_fieldTitleDocuments__SxLgw","fieldTitleNotes":"RejectModal_fieldTitleNotes__u1GMp"};